<template>
  <div class="communication-wrapper">
    <Title
      title="智慧交流"
      subTitle="Intelligent Care"
      @showMore="showMore"
    ></Title>
    <!-- 次数统计 -->
    <div class="communication-statistics">
      <div
        v-for="item in statisticsList"
        :key="item.name"
        class="communication-statistics-item"
      >
        {{ item.name }}&nbsp;<span class="number-color">{{
          formatter(item.value)
        }}</span
        >&nbsp;{{ item.label }}
      </div>
    </div>
    <div style="display: flex">
      <div id="communication-columnar-chart"></div>
      <div id="communication-line-chart"></div>
    </div>
  </div>
</template>

<script>
import Title from "@/components/Commen/Title";
const echarts = require("echarts");
import lineChart from "./charts/line";
import columnarChart from "./charts/columnar";
import { mapState, mapActions } from "vuex";
import pollingFunction from "@/utils/tools";
export default {
  components: {
    Title,
  },
  data() {
    return {
      branchId: 6627,
      yearMonthStart: "2022-01",
      yearMonthEnd: "2022-05",
      callInfoDate: "",
      statisticsList: [
        {
          name: "远程交流",
          value: 218,
          label: "次",
        },
        {
          name: "志愿老年人",
          value: 312,
          label: "人",
        },
        {
          name: "远程交流时长",
          value: 4396,
          label: "小时",
        },
        {
          name: "老年大学课堂",
          value: 18,
          label: "次",
        },
      ],
      currentDate: "0",
      orderNum: 133,
      mobileLoginNum: 218,
      feedbackNum: 218,
      pagedata: {},
      pollingST: null,
    };
  },
  computed: {
    ...mapState(["communicationData"]),
  },
  mounted() {
    // this.drawChart();
    // 调用轮询;
    if (!this.pollingST) {
      setTimeout(() => {
        this.pollingST = pollingFunction(this.getData, 3000);
      }, 3000);
    }
    this.getData();
  },
  methods: {
    ...mapActions(["getCommunicationData"]),
    async getData() {
      let json = {
        callInfoDate: this.getTime(),
        yearMonthStart: this.yearMonthStart,
        yearMonthEnd: this.yearMonthEnd,
        branchId: this.branchId,
      };
      await this.getCommunicationData(json);
      this.pagedata = this.communicationData.data.data;
      this.$set(
        this.statisticsList[0],
        "value",
        this.communicationData.data.data.bizChatCount
      );
      this.$set(
        this.statisticsList[1],
        "value",
        this.communicationData.data.data.elderVolCount
      );
      this.$set(
        this.statisticsList[2],
        "value",
        (this.communicationData.data.data.sumMin / 60).toFixed()
      );
      this.$set(
        this.statisticsList[3],
        "value",
        this.communicationData.data.data.elderClassCount
      );
      // 活动趋势
      // this.pagedata.actList
      let data1 = {
        xdata: [],
        ydata1: [],
        ydata2: [],
      };
      this.pagedata.actList.forEach((item, index) => {
        if (item.activityType == 1) {
          item.rows.forEach((item1, index) => {
            data1.xdata.push(item1.month);
            data1.ydata1.push(item1.number);
          });
        } else {
          item.rows.forEach((item1, index) => {
            data1.ydata2.push(item1.number);
          });
        }
      });
      // 课堂趋势
      let data2 = {
        xdata: [],
        ydata1: [],
        ydata2: [],
        ydata3: [],
      };
      this.pagedata.calList.forEach((item, index) => {
        if (item.curriculumType == 1) {
          item.rows.forEach((item, index) => {
            data2.xdata.push(item.month);
            data2.ydata1.push(item.number);
          });
        } else if (item.curriculumType == 2) {
          item.rows.forEach((item, index) => {
            data2.ydata2.push(item.number);
          });
        } else {
          item.rows.forEach((item, index) => {
            data2.ydata3.push(item.number);
          });
        }
      });

      this.drawChart(data1, data2);
    },
    drawChart(data1, data2) {
      let lineName = ["线上文娱", "线下活动"];
      this.communicationLineChart = echarts.init(
        document.getElementById("communication-line-chart")
      );
      this.communicationLineChart.setOption(lineChart(data1, lineName));
      this.communicationColumnarChart = echarts.init(
        document.getElementById("communication-columnar-chart")
      );

      let columnarName = ["健康教育", "手机知识", "防诈骗"];
      this.communicationColumnarChart.setOption(
        columnarChart(data2, columnarName)
      );
    },
    showMore() {
      this.$store.commit("setServiceDrawer", true);
      this.$store.commit("setCurrentMenu", "communication");
    },
    formatter(number) {
      const numbers = number.toString().split("").reverse();
      const segs = [];

      while (numbers.length) segs.push(numbers.splice(0, 3).join(""));

      return segs.join(",").split("").reverse().join("");
    },
    getTime() {
      let date_ = new Date();
      let seperator1 = "-";
      let year = date_.getFullYear();
      let month = date_.getMonth() + 1;
      let strDate = date_.getDate();
      return year + seperator1 + month + seperator1 + strDate;
    },
  },
  destroyed() {
    clearTimeout(this.pollingST);
  },
};
</script>

<style lang="scss" scoped>
.communication-wrapper {
  width: 460px;
  position: absolute;
  bottom: 180px;
}
.number-color {
  color: rgb(237, 255, 0);
}
.communication-statistics {
  display: flex;
  flex-wrap: wrap;
  color: #fff;
  margin-top: 15px;
  .communication-statistics-item {
    width: 50%;
  }
}

.number-statistics {
  position: relative;
  top: -290px;
  left: 230px;
  color: rgb(222, 246, 255);
}
#communication-columnar-chart,
#communication-line-chart {
  width: 230px;
  height: 250px;
}
</style>
